export class UserTypeConstants {
  static DWN_USER = 'NETCRACKER';
  static LEGACY_USER = 'TELENET_LEGACY';
  static RESIDENTIAL_USER = 'RESIDENTIAL';
  static BUSINESS_USER = 'BUSINESS';
}
